import { render } from "./OcLabelsContent.vue?vue&type=template&id=5ce90a8e&scoped=true"
import script from "./OcLabelsContent.vue?vue&type=script&lang=js"
export * from "./OcLabelsContent.vue?vue&type=script&lang=js"

import "./OcLabelsContent.vue?vue&type=style&index=0&id=5ce90a8e&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce90a8e"]])

export default __exports__